export default () => {

    let paged = 1;
    let totalPages = Math.round($('.block-lexicon').data('totalpages'));

    if ( 1 >= totalPages ) {
        $('.js-load-lexikon').parent().hide();
    }

    $('.js-load-lexikon').click(function(e){
        e.preventDefault();
        paged += 1;
        filterLexikon($(this));
    });

    $('.js-filter-lexicon').click(function(e){
        e.preventDefault();
        paged = 1;
        $(this).addClass('active').siblings('.js-filter-lexicon').removeClass('active');
        $(this).parents('form').find('[name="letter"]').val($(this).data('type'));
        filterLexikon($(this));
    });

    $('.form-search-lexikon').submit(function(e){
        e.preventDefault();
        paged = 1;
        filterLexikon($(this));
    });

    $('.section-lexicon .btn-clear-filter').click(function(e){
        e.preventDefault();
        paged = 1;
        let $form = $(this).parents('form');
        $form[0].reset();
        $form.find('.js-filter-lexicon[data-type="all"]').addClass('active').siblings('.js-filter-lexicon').removeClass('active');
        $form.find('[name="search"]').val('');
        filterLexikon($(this));
    });

    function filterLexikon($el){
        let $parent = $el.parents('.section-lexicon');
        let $search = $parent.find('[name="search"]').val();
        let $letter = $parent.find('.box-filter.active').data('type');
        let lexikonWrapp = $parent.find('.block-lexicon-wrap');

        $('.loader').show();

        $.ajax({
            url: myajax.url,
            dataType: 'json',
            method: 'POST',
            data: {
                action: 'filter_lexikon',
                search: $search,
                letter: $letter,
                paged: paged,
            },
            success(data) {
                let newLexikon = $(data.content);
                lexikonWrapp.html(newLexikon);
                totalPages = Math.round($parent.find('.block-lexicon').data('totalpages'));

                if ( 1 >= totalPages  ) {
                    $parent.find('.js-load-lexikon').parent().hide();
                }
                else {
                    $parent.find('.js-load-lexikon').parent().show();
                }


            },
            complete: function(){
                $('.loader').hide();
            },
        });
    }

}
